export const SET_DEFINITIONS = 'parser/api/setDefinitions'
